import { useContext } from 'react';

import { TutorialContext } from '../contexts/TutorialContext';

// ----------------------------------------------------------------------

const useTutorial = () => useContext(TutorialContext);

export default useTutorial;
